<template>
  <div class="screen screen__contact" v-loading="!page.title">
    <page-banner :heading="page.title" :sub-heading="page.subheading" />
    <el-container direction="vertical" class="page--container full-height">
      <el-row>
        <el-col :md="{ span: 16, offset: 4 }">
          <about-menu />
        </el-col>
      </el-row>
      <el-row>
        <el-col :md="{ span: 16, offset: 4 }">
          <section class="page--section">
            <user-based-content :approved="page.approvedContent" :unapproved="page.unapprovedContent"
              :anon="page.anonContent" />
          </section>
        </el-col>
      </el-row>
      <el-row>
        <el-col :md="{ span: 16, offset: 4 }">
          <section class="page--section">
            <contact-form />
          </section>
        </el-col>
      </el-row>
    </el-container>
    <footer-main />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import singles from '@/components/singles';
import UserBasedContent from '@/components/singles/UserBasedContent';
import ContactForm from '@/components/singles/ContactForm';
import PageBanner from '@/components/PageBanner.vue';
import AboutMenu from '@/screens/about/AboutMenu.vue';
import FooterMain from '@/components/footer/FooterMain.vue';
const PAGE_KEY = 'contact';

export default {
  name: 'Contact',
  data() {
    return {
      page: {}
    };
  },
  components: {
    AboutMenu,
    UserBasedContent,
    ContactForm,
    PageBanner,
    FooterMain,
  },
  methods: {
    ...mapActions(singles.store.namespace, ['getPage']),
  },
  beforeMount() { this.getPage(PAGE_KEY).then(page => this.page = page) },
}
</script>

<style lang="scss" scoped>
@import '@/assets/base/_variables.scss';

.full-height {
  min-height: calc(100vh - 105px);
}

.screen__contact {
  .el-row {
    background-color: $--color-white;
  }
}
</style>
